import apiClient from './client'
import type { ApiResponse } from '@portal/types'

export interface DashboardStats {
  todayPaymentsCount: number
  todayPaymentsTotalPaise: number
  pendingApprovalsCount: number
  thisMonthTotalPaise: number
}

export interface BalanceData {
  balancePaise: number | null
  accountNo: string | null
  error?: string
  lastChecked: string
}

export const dashboardApi = {
  stats: () =>
    apiClient.get('/api/dashboard/stats') as unknown as Promise<ApiResponse<DashboardStats>>,
  balance: () =>
    apiClient.get('/api/balance') as unknown as Promise<ApiResponse<BalanceData>>,
}
